import InfoTooltip from '~/components/InfoTooltip';
import TextField from '~/components/TextField';
import { destinationTypeCustomHtml } from '~/lib/destinations';
import { hasError } from '~/lib/graphql';
import { segmentTypes } from '~/lib/segments';
import TriggerType from '~/pages/destinations/components/TriggerType';

import ContentBox from '../../components/ContentBox';
import FormContentWrapper from '../../components/FormContentWrapper';
import FormHeader from '../../components/FormHeader';
import styles from './styles';

class CustomHtml extends React.Component {
  state = {
    source: null,
    triggerType: 'page',
  };

  UNSAFE_componentWillMount() {
    if (this.props.destination) {
      this.setState({
        ...this.props.destination,
        ...this.props.destination.config,
      });
    }
  }

  handleFieldChange = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    const { classes, errors, segment, destination, FormFooter } = this.props;

    const { source, triggerType } = this.state;

    const destinationFlowDescription = destination
      ? 'Will append your Custom HTML'
      : null;

    return (
      <>
        <FormHeader
          destinationType={destinationTypeCustomHtml}
          destinationFlowDescription={destinationFlowDescription}
          segmentName={segment.name}
          segmentCollection={segment.collection.name}
        />
        <FormContentWrapper>
          <h2 className={classes.subheading}>Trigger</h2>
          <span className={classes.triggerSubtext}>
            Select the event that triggers this Destination to run.{' '}
            <a
              href="https://help.clearbit.com/hc/en-us/articles/360023453694"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline' }}>
              Learn more
            </a>
          </span>

          <TriggerType
            errors={errors}
            handleChange={this.handleFieldChange}
            triggerType={triggerType}
            triggerTypes={[
              {
                value: 'page',
                label: (
                  <div className="flex items-center">
                    On&nbsp;<strong>page view</strong>{' '}
                    <InfoTooltip
                      title={`The destination is triggered every time ${
                        segment.type === segmentTypes.company
                          ? 'someone at the company'
                          : 'a person'
                      } hits your website.`}
                    />
                  </div>
                ),
              },
            ]}
          />

          <h2 className={classes.subheading}>Configure Custom HTML</h2>

          <ContentBox>
            <TextField
              className={classes.field}
              error={hasError(errors, 'source')}
              fullWidth
              multiline
              rows="8"
              defaultValue={source}
              label="Custom HTML"
              onChange={(event) => {
                this.handleFieldChange('source', event.target.value);
              }}
              variant="standard"
              placeholder="Enter your HTML"
              InputProps={{
                classes: { input: classes.sourceInput },
              }}
            />
          </ContentBox>
        </FormContentWrapper>
        <FormFooter
          destinationConfig={{
            config: {
              source: this.state.source,
            },
            triggerType: this.state.triggerType,
          }}
        />
      </>
    );
  }
}

CustomHtml.propTypes = {
  classes: PropTypes.object.isRequired,
  destination: PropTypes.object,
  errors: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  typename: PropTypes.string.isRequired,
};

export default withStyles(
  (theme) => ({
    ...styles(theme),
  }),
  { name: 'SegmentDestinationNewCustomHtml' },
)(CustomHtml);
